import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';

export const TopUnavailable = () => (
  <InlineText2 color="superblack_100">Размещение Топ-объявления недоступно</InlineText2>
);
